module.exports = __webpack_public_path__ + "img/iso13485.091462d.png";